import { Folder20Regular } from '@/components/Icon'

/** @typedef {{ id: string, label: string, Icon: import('react').ComponentType }} DesignPreviewProjectOption */

/** @type {DesignPreviewProjectOption[]} */
export const DESIGN_PREVIEW_PROJECT_OPTIONS = [
  { id: 'nexus-procurement', label: 'Nexus Procurement', Icon: Folder20Regular },
  { id: 'do-sense-app', label: 'Chat By DataObserve App', Icon: Folder20Regular },
  { id: 'marketing-site', label: 'Marketing Site', Icon: Folder20Regular },
  { id: 'mobile-banking', label: 'Mobile Banking', Icon: Folder20Regular },
]
